<template>
  <div class="ticket-info">
    <div class="block">
      <!-- 乗車日 -->
      <ViBoardingDate :boarding-date="vacancyInquiry.boarding_date" />

      <!-- 列車名 -->
      <ViTrainInfo
        v-if="props.selectedTrainInfo"
        :name="props.selectedTrainInfo.train.name"
        :cars-formation-name="props.selectedTrainInfo.cars_formation.name"
      />

      <!-- 区間 -->
      <ViStationSection
        v-if="props.selectedTrainInfo"
        :from="props.selectedTrainInfo.from_station.name"
        :to="props.selectedTrainInfo.to_station.name"
      />

      <!-- 時間 -->
      <ViDepartureAndArrival
        v-if="props.selectedTrainInfo"
        :departure="props.selectedTrainInfo.departure_at"
        :arrival="props.selectedTrainInfo.arrival_at"
      />

      <!-- 人数 -->
      <StorePassenger
        :adult="inputtedInfoOnBooking.adult_count"
        :child="inputtedInfoOnBooking.child_count"
        :is-saloon="props.isSaloon"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "MFITTTicketInfo",
  props: {
    selectedTrainInfo: {
      type: Object,
      required: false,
    },
    // サルーン席の場合は、人数の表記が異なる
    isSaloon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const isReadyToDraw = ref(true);
    const vacancyInquiry = computed(
      () => store.getters["MFITT/vacancyInquiry"]
    );

    const inputtedInfoOnBooking = computed(
      () => store.getters["MFITT/inputtedInfoOnBooking"]
    );

    watchEffect(() => {
      if (vacancyInquiry.value != null) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
      vacancyInquiry,
      inputtedInfoOnBooking,
      props,
    };
  },
};
</script>

<style lang="scss" scoped>
.ticket-info {
  width: 100%;
  background-color: #f8f3ec;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0px;
}
.ticket-info .block {
  display: table;
  font-size: 13px;
}
</style>
